<template>
  <div class="inquiry-float-root">
    <!-- 桌面端：右侧悬浮按钮 -->
    <div class="inquiry-float desktop-only">
      <a-tooltip placement="left" :title="locale === 'zh' ? '立即询盘' : 'Inquire Now'">
        <div class="float-btn" @click="openInquiry">
          <a-icon type="message" />
        </div>
      </a-tooltip>
      <a-tooltip placement="left" :title="locale === 'zh' ? '电话咨询' : 'Call Us'">
        <div class="float-btn phone" @click="callPhone">
          <a-icon type="phone" />
        </div>
      </a-tooltip>
    </div>

    <!-- 移动端：底部固定按钮 -->
    <div class="mobile-bottom-bar mobile-only">
      <a-button type="primary" size="large" block class="cta-btn" @click="openInquiry">
        <a-icon type="message" /> {{ locale === 'zh' ? '立即询盘' : 'Inquire Now' }}
      </a-button>
    </div>

    <!-- 询盘弹窗 -->
    <a-modal
      v-model="inquiryVisible"
      :title="locale === 'zh' ? '发送询盘' : 'Send Inquiry'"
      :width="560"
      :footer="null"
      destroyOnClose
    >
      <InquiryForm
        :product-name="inquiryProduct"
        @success="inquiryVisible = false"
      />
    </a-modal>
  </div>
</template>

<script>
import InquiryForm from '@/components/common/InquiryForm.vue'

export default {
  name: 'InquiryFloat',
  components: { InquiryForm },
  props: {
    productName: { type: String, default: '' }
  },
  data() {
    return {
      inquiryVisible: false,
      inquiryProduct: ''
    }
  },
  computed: {
    locale() {
      return this.$store.locale
    }
  },
  mounted() {
    this.$root.$on('open-inquiry', this.onRootInquiry)
  },
  beforeDestroy() {
    this.$root.$off('open-inquiry', this.onRootInquiry)
  },
  methods: {
    openInquiry() {
      this.inquiryProduct = this.productName || ''
      this.inquiryVisible = true
    },
    onRootInquiry(productName) {
      this.inquiryProduct = productName || ''
      this.inquiryVisible = true
    },
    callPhone() {
      window.location.href = `tel:${this.$store.contact.phone}`
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/variables.less';

.desktop-only {
  @media @mobile {
    display: none !important;
  }
  @media @tablet {
    display: none !important;
  }
}

.mobile-only {
  display: none;

  @media @mobile {
    display: block;
  }
  @media @tablet {
    display: block;
  }
}

.inquiry-float {
  position: fixed;
  right: 20px;
  bottom: 120px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.float-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: @accent-red;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.35);
  transition: all @duration-fast @ease-professional;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(231, 76, 60, 0.45);
  }

  &.phone {
    background: @primary-dark;
    box-shadow: 0 4px 12px rgba(10, 40, 89, 0.35);

    &:hover {
      box-shadow: 0 6px 20px rgba(10, 40, 89, 0.45);
    }
  }

}

.mobile-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 10px 16px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);

  .cta-btn {
    background: @accent-red;
    border-color: @accent-red;
    color: #fff;
    font-size: 16px;
    height: 44px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover, &:focus {
      background: darken(@accent-red, 8%);
      border-color: darken(@accent-red, 8%);
    }
  }
}
</style>
